<template>
  <div id="data-list-gestao-status" class="data-list-container">
    <vs-alert
      color="warning"
      title="Atenção!!"
      class="my-3"
      style="height: auto !important"
      closable
      :active.sync="showAviso"
    >
      As alterações de status podem levar até 2 minutos para serem efetivadas.
    </vs-alert>

    <vx-card>
      <vs-table
        noDataText="Nenhum item encontrado"
        ref="table"
        :data="itens"
        pagination
        :max-items="itemsPerPage"
        multiple
        v-model="selected"
      >
        <!-- Header -->
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div class="flex">
            <vs-button
              icon-pack="feather"
              icon="icon-check"
              @click="aprova()"
              color="success"
              :disabled="selected.length == 0"
            >
              Aprovar Alteração de Status
            </vs-button>

            <vs-button
              icon-pack="feather"
              icon="icon-x"
              @click="reprova()"
              color="danger"
              type="border"
              class="ml-4"
              :disabled="selected.length == 0"
            >
              Reprovar Alteração de Status
            </vs-button>
          </div>

          <!-- Seleção das Páginas -->
          <SelectPagination
            :currentPage="currentPage"
            :itemsPerPage="itemsPerPage"
            :length="itens.length"
            @update="itemsPerPage = $event"
            v-if="itens.length != 0"
          />

          <div class="my-4" v-if="itens.length == 0">
            <vs-button
              icon-pack="feather"
              icon="icon-refresh-ccw"
              @click="loadData()"
              type="flat"
            >
            </vs-button>
          </div>
        </div>

        <template slot="thead">
          <vs-th>Tipo de Alteração</vs-th>
          <vs-th>Variação</vs-th>
          <vs-th colspan="2" class="thead-center">Associado</vs-th>
          <vs-th colspan="2" class="thead-center">Veículo</vs-th>
        </template>

        <!-- Body -->
        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <!-- Tipo de Alteração -->
              <vs-td>{{ tr.descricaoVariacao }}</vs-td>

              <!-- Variação -->
              <vs-td>{{ tr.variacao }}</vs-td>

              <!-- Associado / Novo Status -->
              <vs-td>
                {{ tr.nomeAssociado }}
                <router-link
                  class="inline-block"
                  target="_blank"
                  :to="`/DetalheAssociado/${tr.idAssociado}`"
                >
                  <feather-icon icon="ExternalLinkIcon" svgClasses="h-4 w-4" />
                </router-link>
              </vs-td>

              <vs-td>
                <span class="chip mb-1">Novo Status</span>
                <span>{{ tr.novoStatusAssociado }}</span>
              </vs-td>

              <!-- Veículo / Novo Status -->
              <vs-td>
                {{ tr.veiculo }}
                <router-link
                  class="inline-block"
                  target="_blank"
                  :to="`/DetalheAssociado/${tr.idAssociado}`"
                >
                  <feather-icon icon="ExternalLinkIcon" svgClasses="h-4 w-4" />
                </router-link>
              </vs-td>

              <vs-td>
                <span class="chip mb-1">Novo Status</span>
                <span>{{ tr.novoStatusVeiculo }}</span>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import services from '../../../../services';
import { translateDictionary } from './../../configuracoes/Status/dictonary';
import notify from '../../../../utils/notify';

import SelectPagination from '../../../../utils/list/header/SelectPagination.vue';

export default {
  components: {
    SelectPagination,
  },
  data() {
    return {
      isMounted: false,
      itemsPerPage: 50,
      itens: [],
      selected: [],
      showAviso: false,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    async loadData() {
      try {
        this.$vs.loading();
        this.itens = [];
        this.selected = [];
        this.showAviso = false;

        const response = await services.getAll(
          'status',
          undefined,
          'list-maquina-status-acoes',
        );

        if (response.data.length) {
          response.data.forEach((element) => {
            const variacao = translateDictionary(
              JSON.parse(element.jsonFacilitador),
            );

            this.itens.push({
              ...element,
              variacao,
              check: false,
            });
          });
        }
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    aprova() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: `Confirmação`,
        text: 'Deseja aprovar as alterações selecionadas?',
        accept: this.submitAprovacao,
        acceptText: 'Sim',
        cancelText: 'Não',
      });
    },
    async submitAprovacao() {
      await this.aprovaReprova();
      this.showAviso = true;
      notify.notifySuccess(this.$vs, 'Aprovação realizada com sucesso!');
    },
    reprova() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirmação`,
        text: 'Deseja reprovar as alterações selecionadas?',
        accept: this.submitReprova,
        acceptText: 'Sim',
        cancelText: 'Não',
      });
    },
    async submitReprova() {
      await this.aprovaReprova(false);
      notify.notifySuccess(this.$vs, 'Reprovação realizada com sucesso!');
    },
    async aprovaReprova(aprova = true) {
      try {
        if (!this.selected.length) {
          return;
        }

        this.$vs.loading();

        const listIdAcao = this.selected.map((element) => {
          return element.idAcao;
        });

        const action = aprova
          ? 'aprova-execucao-maquina-status'
          : 'reprova-execucao-maquina-status';

        await services.post('status', action, listIdAcao);

        await this.loadData();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  mounted() {
    this.isMounted = true;
    this.loadData();
  },
};
</script>

<style lang="scss">
@import './../../../../utils/list/style-table.scss';

#data-list-gestao-status {
  @include style-table;

  .thead-center {
    .vs-table-text {
      justify-content: center;
    }
  }
}
</style>

<style scoped>
span {
  display: block;
}

.chip {
  background: rgba(var(--vs-success), 1);
  color: rgba(255, 255, 255, 0.9);
  border-radius: 0.25rem !important;
  padding: 2px 4px;
  font-weight: 700;
  display: inline-block !important;
}
</style>
